import type { EventDataEditor } from './type';
import store from '@/app/store/store';
import { keyRegisterEvent } from './actions.config';

/**
 * scrolling to percentage action
 */
const scrollingToPercentage = (): EventDataEditor => {
  const output: EventDataEditor = {
    key: 'scrolling-to-percentage',
    name: 'Scrolling to percentage',
    type: 1,
    description: 'Show when the user scrolls to a percentage of the way down the content',
  };
  output.settings = [
    {
      key: 'percentage',
      name: 'Percentage',
      value: 50,
      min: 0,
      max: 100,
      step: 1,
      valueType: '%',
      type: 'range',
    },
  ];

  output.settings.unshift({
    key: 'condition',
    name: 'Trigger when',
    value: 'gte',
    type: 'select',
    options: [
      {
        value: 'gte',
        text: 'Scroll top greater than',
      },
      {
        value: 'lt',
        text: 'Scroll top less than',
      },
    ],
  });
  output.settings.push({
    key: 'runtime',
    name: 'Run ',
    type: 'select',
    value: 'once',
    options: [
      {
        value: 'once',
        text: 'Only one time',
      },
      {
        value: 'infinite',
        text: 'Everytime condition met',
      },
    ],
  });

  return output;
};

/**
 * pageDefaultEvents
 */
export const pageDefaultEvents = (): EventDataEditor[] => [
  {
    key: 'scroll-into-view',
    name: 'Scroll Into view',
    type: 1,
    description: 'Trigger when the elements scroll into view or first appear',
  },
  {
    key: 'scrolling-in-view',
    name: 'While scrolling in view',
    type: 1,
    description: 'Trigger while the elements scroll through view port',
  },
  scrollingToPercentage(),
  {
    key: 'after-page-loaded',
    name: 'After page finish loading',
    type: 1,
    description: 'Trigger after page load',
  },
  {
    key: 'exit-page',
    name: 'Exit Page',
    type: 1,
    description: 'Trigger when user is about to exit the page (exit intent)',
  },
];

export const atomDefaultEvents: EventDataEditor[] = [
  {
    key: 'click',
    name: 'Mouse Click',
    type: 2,
    description: 'Trigger on mouse click',
  },
  {
    key: 'mouseenter',
    name: 'Mouse Enter',
    type: 2,
    description: 'Trigger when mouse enter the object',
  },
  {
    key: 'mouseleave',
    name: 'Mouse Leave',
    type: 2,
    description: 'Trigger when mouse leave the object',
  },
];

/**
 * get custom Events
 * @param atomLabel .
 * @returns ..
 */
export const customEvents = (atomLabel = ''): EventDataEditor[] => {
  const custom = store.getValue(keyRegisterEvent) || [];
  if (!atomLabel) {
    return custom;
  }

  const events = [];
  for (let i = 0; i < custom.length; i++) {
    if (custom[i].atomLabel && custom[i].atomLabel == atomLabel) {
      events.push(custom[i]);
    }
  }
  return events;
};

/**
 * listEvents;
 * @returns ..
 */
export const listEvents = (): EventDataEditor[] => {
  const custom = customEvents();
  if (custom) {
    return JSON.parse(JSON.stringify([...pageDefaultEvents(), ...atomDefaultEvents, ...custom]));
  }
  return JSON.parse(JSON.stringify([...pageDefaultEvents(), ...atomDefaultEvents]));
};
